import { Cnae } from './../models/Cnae.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { UrlBuilder } from '../models/utils/url-builder.model';
import { CnaeSearch } from '../models/CnaeSearch.model';

@Injectable()
export class CnaeService {

  constructor(private httpClient: HttpClient) { }

  endPoint: String = "/sap-items";

  async getAllItems(types: number[]): Promise<Cnae[]> {
    const query = types.map(type => `type=${type}`).join('&');
    let items = new Array<Cnae>();
    let itemsServer = await this.httpClient.get(`${this.endPoint}/all?${query}`);
    for (let i of itemsServer) {
      let item = new Cnae();
      item.loadFromServer(i);
      items.push(item);
    }
    return items;
  }

  async getById(id): Promise<Cnae>{
      var cnaeToEdit = new Cnae();
      var response = await this.httpClient.get(`${this.endPoint}/${id}`);
      cnaeToEdit.loadFromServer(response);
      return cnaeToEdit;
  }

  async create(cnae: Cnae){
    return await this.httpClient.post(this.endPoint, cnae);
  }

  async update(cnae: Cnae){
      return await this.httpClient.update(this.endPoint, cnae._id, cnae);
  }

  async searchCnae(cnaeSearch: CnaeSearch): Promise<Cnae[]> {

    const builder = new UrlBuilder([
          { key: "skip", value: cnaeSearch.skip },
          { key: "limit", value: cnaeSearch.limit }
      ]);

      var keyValueParams = [];

      keyValueParams.push({ key: "name", value: cnaeSearch.name });
      keyValueParams.push({ key: "sapItemCode", value: cnaeSearch.sapItemCode });

      for (let type of cnaeSearch.types)
            keyValueParams.push({ key: "type", value: type });

        for (let status of cnaeSearch.status)
            keyValueParams.push({ key: "status", value: status });


      builder.addQueryStringParamsInsideFilter(keyValueParams);

      let url = builder.buildUrl(`${this.endPoint}`);

      let response = await this.httpClient.get(url);
      cnaeSearch.totalItems = response.totalItems;
      let cnaeModel = new Array<Cnae>();
      for (let cnae of response.sapItems){
          var cnaesSearch = new Cnae();
          cnaesSearch.loadFromServer(cnae)
          cnaeModel.push(cnaesSearch);
      }

      return cnaeModel;
  }

  async getAllCnaesSap(): Promise<any[]> {
    return await this.httpClient.get(`${this.endPoint}/cnaes-sap`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/cnae.service.ts